export default __webpack_public_path__ + "static/media/arrow.3ee1cd66.svg";